const formGeneratePaymentApplication = [
  {
    label: "STUDENT_MANAGEMENT.FORM.PAYMENT.DATE_PAYMENT_LABEL",
    name: "payment_date",
    placeholder: "STUDENT_MANAGEMENT.FORM.PAYMENT.DATE_PAYMENT_PLACEHOLDER",
    type: "date",
    typeForm: "date",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2.5, lg: 2.5 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PAYMENT.DATE_PAYMENT_REQUIRED",
    disable: true,
    section: "payment",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PAYMENT.TIME_PAYMENT_LABEL",
    name: "payment_time",
    placeholder: "STUDENT_MANAGEMENT.FORM.PAYMENT.TIME_PAYMENT_PLACEHOLDER",
    type: "input",
    typeForm: "time",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2.5, lg: 2.5 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PAYMENT.TIME_PAYMENT_REQUIRED",
    disable: true,
    section: "payment",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PAYMENT.CURRENCY_PAYMENT_LABEL",
    name: "currency",
    placeholder: "STUDENT_MANAGEMENT.FORM.PAYMENT.CURRENCY_PAYMENT_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    formSize: "small",
    optionName: "currency",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PAYMENT.CURRENCY_PAYMENT_REQUIRED",
    disable: true,
    section: "payment",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PAYMENT.BALANCE_AMOUNT_LABEL",
    name: "amount",
    placeholder: "STUDENT_MANAGEMENT.FORM.PAYMENT.BALANCE_AMOUNT_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PAYMENT.BALANCE_AMOUNT_REQUIRED",
    disable: true,
    section: "payment",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PAYMENT.PAYMENT_TYPE_LABEL",
    name: "payment_type",
    placeholder: "STUDENT_MANAGEMENT.FORM.PAYMENT.PAYMENT_TYPE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PAYMENT.PAYMENT_TYPE_REQUIRED",
    disable: true,
    section: "payment",
  },

  // Add more fields as needed
];

export default formGeneratePaymentApplication;
